import MUIButton from "@material-ui/core/Button";
import React, { ButtonHTMLAttributes, FC, ReactNode } from "react";
import { Theme } from "@material-ui/core/styles";
import { styled } from "@material-ui/styles";

type PrimaryButtonProps = {
  children: ReactNode;
  onClick?: ButtonHTMLAttributes<HTMLButtonElement>["onClick"];
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
};

const StyledButton = styled(MUIButton)(({ theme }: { theme: Theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: 7,
  height: 36,
  padding: "0 20px",
  borderRadius: 8,
  border: "none",
  background: theme.palette.brand.coral,
  color: theme.palette.brand.white,
  fontSize: 13,
  fontWeight: 600,
  textTransform: "none",
  boxShadow: "0 1px 3px rgba(240,100,73,0.3)",
  "&:hover": {
    background: theme.palette.brand.coralHover,
    transform: "translateY(-1px)",
  },
}));

const PrimaryButton: FC<PrimaryButtonProps> = ({ children, onClick, type = "button", disabled }) => (
  <StyledButton disableElevation type={type} onClick={onClick} disabled={disabled}>
    {children}
  </StyledButton>
);

export default PrimaryButton;
